<template>
    <img class="back" :src='src' @click="handleClick"/>
</template>
<script>
export default {
    props:{
        src:{
            
        }
    },
    methods:{
        handleClick(){
            this.$emit('click')
        }
    }
}
</script>
<style lang="less" scoped>
.back{
width:1.05rem;
height: 0.32rem;
  position: fixed;
  left: 0px;
  bottom: 1rem;
  cursor: pointer;
}
</style>
